import styled from 'styled-components';

export const StyledRedactionProposal = styled.div`
   display: flex;
   flex-direction: column;
   gap: 12px;
   padding: 12px;
   border: 1px solid ${(props) => props.theme.borderLighter};
   border-radius: 8px;
   background-color: ${(props) => props.theme.backgroundLightest};
`;

StyledRedactionProposal.displayName = 'StyledRedactionProposal';

export const StyledRedactionProposalTitle = styled.h3`
   margin: 0;
   font-size: 13px;
   font-weight: 600;
   color: ${(props) => props.theme.secondary};
`;

StyledRedactionProposalTitle.displayName = 'StyledRedactionProposalTitle';

export const StyledRedactionProposalText = styled.p`
   margin: 0;
   font-size: 13px;
   color: ${(props) => props.theme.textBody};
   line-height: 1.5;
   white-space: pre-wrap;
`;

StyledRedactionProposalText.displayName = 'StyledRedactionProposalText';

export const StyledRedactionActions = styled.div`
   display: flex;
   gap: 8px;
   align-items: center;
   justify-content: space-around;
`;

StyledRedactionActions.displayName = 'StyledRedactionActions';
